const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const getRoles = () => async () => axiosCall.get('roles');

    return {
        getRoles,
    };
};

export default initActions;
